import React from "react";
import {Box, HStack, Text, VStack} from "@chakra-ui/react";
import {ReactComponent as UserIcon} from "../../../../assets/icons/profile/user_icon_neutral.svg";
import {ReactComponent as Globe} from "../../../../assets/icons/language_icon_dark.svg";
import {ReactComponent as Message} from "../../../../assets/icons/profile/envelope_neutral.svg";
import {ReactComponent as Phone} from "../../../../assets/icons/profile/phone_call_neutral.svg";
import {ReactComponent as TelegramIcon} from "../../../../assets/icons/telegramIcon.svg";
import {ReactComponent as BadgeIcon} from "../../../../assets/icons/badge-discount-alt.svg";
import {ReactComponent as CopyIcon} from "../../../../assets/icons/copy-alt.svg";
import {CustomCheckbox, StyledButton} from "../../../../components";

export const CopyWallet = ({user, addStep, isMobile}) => {

    const copyPromocode = () => {
        navigator.clipboard.writeText(user.promocode)
    }

    return (
        <VStack
            gap={'24px'}
            w={'full'}
            align={'start'}
            color={'neutral.600'}
            maxW={'632px'}>
            <HStack
                w={'full'}
                p={isMobile ? '11px':'17px'}
                borderRadius={'8px'}
                bg={'neutral.900'}>
                <UserIcon/>
                <Text fontSize={isMobile ? 'body.sm' : 'body.md'}>
                    {user.firstName}
                </Text>
            </HStack>
            <HStack
                w={'full'}
                p={isMobile ? '11px':'17px'}
                borderRadius={'8px'}
                bg={'neutral.900'}>
                <Message/>
                <Text fontSize={isMobile ? 'body.sm' : 'body.md'}>
                    {user.email}
                </Text>
            </HStack>
            <HStack
                w={'full'}
                p={isMobile ? '11px':'17px'}
                borderRadius={'8px'}
                bg={'neutral.900'}>
                <Phone/>
                <Text fontSize={isMobile ? 'body.sm' : 'body.md'}>
                    {'+' + user.country.code + ' ' + user.phone}
                </Text>
            </HStack>
            <HStack
                w={'full'}
                p={isMobile ? '11px':'17px'}
                borderRadius={'8px'}
                bg={'neutral.900'}>
                <Globe/>
                <Text fontSize={isMobile ? 'body.sm' : 'body.md'}>
                    {user.region}
                </Text>
            </HStack>
            <HStack
                w={'full'}
                p={isMobile ? '11px':'17px'}
                borderRadius={'8px'}
                bg={'neutral.900'}>
                <TelegramIcon/>
                <Text fontSize={isMobile ? 'body.sm' : 'body.md'}>
                    {user.telegramNic}
                </Text>
            </HStack>
            <Box
                w={'full'}
                maxW={'322px'}>
                <HStack mb={'6px'}>
                    <BadgeIcon/>
                    <Text color={'neutral.400'} fontSize={'body.sm'}>
                        Promocode
                    </Text>
                </HStack>
                <HStack
                    w={'full'}
                    p={isMobile ? '11px':'17px'}
                    justifyContent={'space-between'}
                    borderRadius={'8px'}
                    bg={'neutral.900'}>
                    <Text fontSize={isMobile ? 'body.sm' : 'body.md'}>
                        {user.promocode}
                    </Text>
                    <CopyIcon style={{cursor: 'pointer'}} onClick={copyPromocode}/>
                </HStack>
            </Box>
            <Box
                fontSize={isMobile ? 'body.sm' : 'body.md'}
                mt={'24px'}>
                <HStack>
                    <CustomCheckbox/>
                    <Text color={'neutral.500'}>I confirm that the information provided is accurate.</Text>
                </HStack>
                <HStack mt={'17px'}>
                    <CustomCheckbox/>
                    <Text color={'neutral.500'}>I agree to the Terms & Conditions.</Text>
                </HStack>
            </Box>
            <StyledButton
                onClick={addStep}
                w={'full'}
                h={isMobile ? '40px':'56px'}>
                Next
            </StyledButton>
        </VStack>
    )
}